import { EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../app/api.service';
var ComponentSoical = (function () {
    function ComponentSoical(route, apiService, router) {
        this.route = route;
        this.apiService = apiService;
        this.router = router;
        this.submitAt = ""; //顾问第一次回答的时间
        this.context = ""; //追问
        this.onShowToast = new EventEmitter();
        this.ongetStudentAppreciate = new EventEmitter();
        this.ongetMyAppreciate = new EventEmitter();
        this.data = {};
    }
    ComponentSoical.prototype.ngOnInit = function () {
        var _this = this;
        var submitAt = null;
        submitAt = this.submitAt && typeof (this.submitAt) != "undefined" ? this.submitAt.split('.')[0].split('T') : "";
        this.submitAt = submitAt ? submitAt[0] + " " + submitAt[1] : "";
        var list = JSON.parse(JSON.stringify(this.commentList));
        list.map(function (item) {
            var time = null;
            if (item.studentCommentAt && typeof (item.studentCommentAt) != "undefined") {
                time = item.studentCommentAt.split('.')[0].split('T');
                item.studentCommentAt = time[0] + " " + time[1].split(":")[0] + ":" + time[1].split(":")[1];
            }
            if (item.studentCommentByName.length > 10) {
                item.studentCommentByName = item.studentCommentByName.slice(0, 10) + "...";
            }
        });
        this.commentList = list;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.learningPathMetaId = queryParams['learningPathMetaId'];
            _this.projectId = queryParams['projectId'];
        });
    };
    ComponentSoical.prototype.ngAfterViewInit = function () {
    };
    //点赞
    ComponentSoical.prototype.favour = function () {
        var _this = this;
        if (this.tabNum == 0) {
            this.data.relationId = this.myData.relationId;
            this.data.type = "appreciate";
            this.getAppreciate().then(function (result) {
                if ((!!result.some(function (item) { return item.userHomeworkRelationId === _this.myData.relationId; }) === false)) {
                    _this.giveAppreciate(_this.data).then(function (result) {
                        _this.ongetMyAppreciate.emit();
                    });
                }
                else {
                    _this.onShowToast.emit(true);
                }
            });
        }
        else if (this.tabNum == 1) {
            this.data.relationId = this.relationId;
            this.data.type = "appreciate";
            //判断是否已经点过赞
            this.getAppreciate().then(function (result) {
                //没点过
                if ((!!result.some(function (item) { return item.userHomeworkRelationId === _this.relationId; }) === false)) {
                    _this.giveAppreciate(_this.data).then(function (result) {
                        _this.ongetStudentAppreciate.emit({ studentList: _this.studentList, relationId: _this.relationId });
                    });
                }
                else {
                    _this.onShowToast.emit(true);
                }
            });
        }
    };
    //评论
    ComponentSoical.prototype.goComment = function () {
        if (this.projectId) {
            this.router.navigate(['home-work-show-request'], { queryParams: { 'relationId': this.relationId, 'constituteId': this.constituteId, 'tabNum': this.tabNum, type: "comment", comment: this.comment, 'projectId': this.projectId } });
        }
        else if (this.learningPathMetaId) {
            this.router.navigate(['home-work-show-request'], { queryParams: { 'relationId': this.relationId, 'constituteId': this.constituteId, 'tabNum': this.tabNum, type: "comment", comment: this.comment, 'learningPathMetaId': this.learningPathMetaId } });
        }
    };
    //点赞
    ComponentSoical.prototype.giveAppreciate = function (data) {
        return this.apiService.ajax({
            'type': 'post',
            'url': 'ddilearner/v2/user/project/homework/saveOperationLog',
            'data': data
        }).toPromise();
    };
    //点赞列表
    ComponentSoical.prototype.getAppreciate = function () {
        return this.apiService.ajax({
            'type': 'get',
            'url': 'ddilearner/v2/user/project/homework/getOperationLogList/3',
        }).toPromise();
    };
    return ComponentSoical;
}());
export { ComponentSoical };



// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-social/social.ts.pre-build-optimizer.js